import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';


class AdditionalInformationModalConfirm extends React.Component {

    render() {
        return (
            <Modal isOpen={this.props.isOpen} className={"modal-content " + this.props.className}>
                <ModalHeader>{this.props.contentHeader}</ModalHeader>
                <ModalBody>{this.props.contentBody}</ModalBody>
                <ModalFooter>
                    {this.props.previousForm && <Button className="previous-form-btn" color="primary" size="sm" onClick={this.props.previousForm}disabled={this.props.previousDisabled}>{this.props.previousFormText}</Button>}
                    {this.props.saveCloseCallback && <Button color="primary" size="sm" onClick={this.props.saveCloseCallback}>{this.props.saveCloseText}</Button>}
                    {this.props.cancelCallback && <Button color="backward" size="sm" onClick={this.props.cancelCallback}>{this.props.cancelText}</Button>}
                    {this.props.saveAddNewCallback && <Button color="danger" size="sm" onClick={this.props.saveAddNewCallback} disabled={this.props.saveAddNewDisabled}>{this.props.saveAddNewText}</Button>}
                    {this.props.nextForm && <Button className="next-form-btn" color="primary" size="sm" onClick={this.props.nextForm} disabled={this.props.nextDisabled}>{this.props.nextFormText}</Button>}
                </ModalFooter>
            </Modal>
        );
    }
}

// PropTypes: For prop validation
AdditionalInformationModalConfirm.propTypes = {
    isOpen: PropTypes.bool,
    contentHeader: PropTypes.string,
    contentBody: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    confirmCallback: PropTypes.func,
    cancelCallback: PropTypes.func
};

// PropTypes: Defaulting value for optional props
AdditionalInformationModalConfirm.defaultProps = {
    isOpen: false,
    confirmText: 'Yes',
    cancelText: 'No'
};


export default withRouter(AdditionalInformationModalConfirm);
